import { mapActions, mapState } from 'pinia';
import { useContentStore } from '../../stores/content/index.js';
import { useGlobalStore } from '../../stores/global/index.js';
import { useProductStore } from '../../stores/product/index.js';
import SearchFilters from '../search-filters/index.vue';

import TranslationsMixin from '../../mixins/translations';
import ResultsMixin from '../../mixins/results';
import QueryToNameConverterMixin from '../../mixins/queryToNameConverter';

export default {
  name: 'ContentSearchable',
  mixins: [
    TranslationsMixin,
    ResultsMixin,
    QueryToNameConverterMixin,
  ],
  components: {
    SearchFilters,
  },
  props: {
    expandFilter: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    expandFilter() {
      this.isSearchFiltersExpanded = this.expandFilter;
    },
  },
  data() {
    return {
      isSearchFiltersExpanded: this.expandFilter,
    };
  },

  computed: {
    ...mapState(useGlobalStore, ['systemConfig', 'isLoading']),
    ...mapState(useProductStore, ['hasErrorFetchingProduct', 'productDetails']),
    ...mapState(useContentStore, [
      'hasResults',
      'getTopicsTransformed',
      'contentVideoResults',
      'contentResults',
    ]),
    isMobile() {
      return (/iphone|ipod|android|ie|blackberry|fennec/).test(navigator.userAgent.toLowerCase());
    },
    hasNoContentResults() {
      return (
        !this.hasResults(this.contentVideoResults)
        && !this.hasResults(this.contentResults)
        && !this.isLoading
      );
    },
  },
  methods: {
    ...mapActions(useProductStore, ['fetchProductDetailsByIdentifier']),
    onSearchFilterKeywordChange(keyword) {
      const query = JSON.parse(JSON.stringify(this.$route.query));
      if (!keyword) {
        delete query.keywordSearch;

        this.$router.push({
          path: this.$route.path,
          query,
        });
      }
    },
    async onSearchFilterProductFamilyChange(familyName) {
      const query = JSON.parse(JSON.stringify(this.$route.query));
      if (!familyName) {
        delete query.productFamily;

        this.$router.push({
          path: this.$route.path,
          query,
        }).catch((err) => err);
      }
    },

    onSearchFilterSubtopicChange(subtopicName) {
      const query = JSON.parse(JSON.stringify(this.$route.query));

      if (!subtopicName) {
        delete query.issueSubTagName;

        this.$router.push({
          path: this.$route.path,
          query,
        });
      }
    },
    async onSearchFilterProductSelected(eventPayload) {
      const { identifier } = eventPayload;
      const query = JSON.parse(JSON.stringify(this.$route.query));
      if (identifier && query.identifier !== identifier) {
        await this.fetchProductDetailsByIdentifier({ identifier });
      }
    },
    onSearchFilterProductCleared() {
      const query = JSON.parse(JSON.stringify(this.$route.query));

      if (query.identifier) {
        delete query.identifier;
        this.$router.push({
          path: this.$route.path,
          query,
        }).catch((err) => err);
      }
    },
    async onSearchFilterSubmit(queryToSearch) {
      const query = JSON.parse(JSON.stringify(this.$route.query));
      const newQuery = { ...query, ...queryToSearch };
      if (newQuery.identifier) {
        await this.fetchProductDetailsByIdentifier({ identifier: newQuery.identifier });
      }

      if (
        JSON.stringify(this.$route.query) !== JSON.stringify(newQuery)
        && !this.hasErrorFetchingProduct
      ) {
        this.$router.push({
          name: (
            newQuery.identifier || newQuery.productFamily
          ) ? 'tabsView' : 'issuesView',
          query: {
            ...newQuery,
          },
          params: {
            ...this.$route.params,
            tabId: 'topics',
          },
          meta: {
            scrollTo: '.sc__systems-issues__results',
          },
        });

        this.isSearchFiltersExpanded = false;
      }
    },
  },
};
